export enum FileExtension {
  // image
  jpg = 'image/jpeg',
  jpeg = 'image/jpg',
  png = 'image/png',
  gif = 'image/gif',

  // video
  mov = 'video/quicktime',
  flv = 'video/x-flv',
  ogg = 'video/ogg',
  webm = 'video/webm',
  wmv = 'video/x-ms-wmv',
  mp4 = 'video/mp4',
  avi = 'video/avi',
  avi2 = 'video/x-msvideo', // safari detect avi video as x-msvideo
  mpeg = 'video/mpeg',
}
